import axios, { AxiosResponse } from "axios";
import { AnalysisResult } from "../types/analysisResult";
import { AnalysisRequest } from "../types/analysisRequest";
import { JobPostingDto } from "../types/jobPostingDto";
import { api } from "../api/client";
import { AnalyzeResponse } from "../types/analyzeResponse";
import { ScoringRequest } from "../types/scoringRequest";
import { AnalyzeAI } from "../types/analyzeAI";
import { JobPostingAnalysisDto } from "../types/jobPostingAnalysisDto";
import { useState, useCallback } from "react";
import { NextImprovementResponse } from "../types/nextImprovements";
import { ImprovementRequest } from "../types/improvementRequest";

export const useAnalyzeService = () => {
    const serviceUrl = process.env.REACT_APP_SERVICEURL;
    const [suggestionsLoading] = useState(false);
    const [suggestionsError] = useState<string | null>(null);

    const getAnalysisResults = async (req: AnalysisRequest): Promise<AnalysisResult> => {
        const resp = await axios.post(`${serviceUrl}/api/analyze/getanalysis`, req , { headers: { "Content-Type": "application/json" }});
        return resp?.data;
    };

    const getOpenAIAnalysisResults = async (req: ScoringRequest): Promise<AnalyzeResponse> => {
        const resp = await axios.post(`${serviceUrl}/api/analyze/runanalysis`, req, { headers: { "Content-Type": "application/json" }});
        return resp?.data;
    };

    const getPastJobPostingsAnalysis = useCallback(async (userId: string): Promise<JobPostingDto[]> => {
        const resp: AxiosResponse<JobPostingDto[]> = await api.get('/api/users/job-postings');
        const data: JobPostingDto[] = resp && resp.data && Array.isArray(resp.data) ? resp.data : [];
        return data;
    }, []);

    const getPastJobAnalysisByJobPostingId = useCallback(async (jobPostingId: string): Promise<JobPostingAnalysisDto | null> => {
        const resp: AxiosResponse<JobPostingAnalysisDto> = await api
            .get(`/api/users/job-postings/${jobPostingId}`);
        const data: JobPostingAnalysisDto | null = resp && resp.data ? resp.data : null;
        return data;
    }, []);

    const submitJobPostingForAIAnalysis = async (req: AnalysisRequest): Promise<string> => {
        const resp = await axios.post(`${serviceUrl}/api/analyze/submitjobpostingforaianalysis`, req, { headers: { "Content-Type": "application/json" }});
        return resp?.data;
    };

    const submitAnalysisAIResult = async (req: AnalyzeAI): Promise<void> => {
        await axios.post(`${serviceUrl}/api/analyze/submitanalysisairesult`, req, { headers: { "Content-Type": "application/json" }});
    };

    const getSuggestions = async (req: ImprovementRequest): Promise<NextImprovementResponse> => {
        const resp = await axios.post(`${serviceUrl}/api/analyze/getnextimprovements`, req, { headers: { "Content-Type": "application/json" }});
        //const response = await api.get("/api/analyze/getnextimprovements", { params: { req }});
        //const data: NextImprovementResponse = response && response.data ? response.data : null;
        return resp?.data;
    };

    const getPastJobSuggestionByJobPostingId = async (jobPostingId: string): Promise<NextImprovementResponse> => {
        const resp = await axios.post(`${serviceUrl}/api/analyze/getpastjobsuggestionsbyjobpostingid`, { jobPostingId }, { headers: { "Content-Type": "application/json" }});
        return resp?.data;
    };

    return {
        getAnalysisResults: getAnalysisResults,
        getOpenAIAnalysisResults: getOpenAIAnalysisResults,
        getPastJobPostingsAnalysis: getPastJobPostingsAnalysis,
        submitJobPostingForAIAnalysis: submitJobPostingForAIAnalysis,
        submitAnalysisAIResult: submitAnalysisAIResult,
        getPastJobAnalysisByJobPostingId: getPastJobAnalysisByJobPostingId,
        getSuggestions: getSuggestions,
        suggestionsLoading: suggestionsLoading,
        suggestionsError: suggestionsError,
        getPastJobSuggestionByJobPostingId: getPastJobSuggestionByJobPostingId,
    };
}

export const useAnayzeService = useAnalyzeService;
